// THEMES is the overall structure of our themes and actions
export const THEMES = Object.freeze({
  zorgzame_wijken: ["maaltijden", "ouderen", "buddywerking"],
  leefbare_wijken: [
    "sluipverkeer",
    "vlot_verkeer",
    "conflictvrije_kruispunten",
    "verkeersveiligheid",
    "ruimte_voetgangers",
  ],
  groene_wijken: [
    "nieuw_groen",
    "bestaand_groen",
    "ontharding_prive",
    "ontharding_publiek",
  ],
  levendige_wijken: ["sportinfrastructuur", "cultuur", "speeltuinen", "events"],
  winkelende_stad: [
    "promotie",
    "bereikbaar",
    "leegstand",
    "vormingsaanbod",
    "acties_opzetten",
  ],
});
